
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsSalesVatTypesGrid extends Serenity.EntityGrid<PsSalesVatTypesRow, any> {
        protected getColumnsKey() { return PsSalesVatTypesColumns.columnsKey; }
        protected getDialogType() { return PsSalesVatTypesDialog; }
        protected getIdProperty() { return PsSalesVatTypesRow.idProperty; }
        protected getInsertPermission() { return PsSalesVatTypesRow.insertPermission; }
        protected getLocalTextPrefix() { return PsSalesVatTypesRow.localTextPrefix; }
        protected getService() { return PsSalesVatTypesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}